import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OverlayCarga } from '@intelishs-group/ui/overlay-carga';

/**
 * Raiz de composicion.
 *
 * `flogin` no monta shell: es el login central de la plataforma, no una
 * aplicacion con modulos. Se autentica, se elige acceso y se SALE a otro host,
 * asi que no hay un "dentro" que encuadrar con una barra y un menu.
 *
 * El velo va aqui, FUERA de cualquier `@if`, y esa es la razon de que no viva en
 * un layout: el momento que mas necesita taparse —entrar a una aplicacion— es
 * una navegacion completa a otro dominio, con esta pantalla intacta durante uno
 * o dos segundos. Es el mismo criterio que el visor de archivos.
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, OverlayCarga],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
